import toList from "../utils/ComponentUtil";
import Checkbox from "../utils/Checkbox";
import CustomTextField from "../utils/CustomTextField";
import Carousel from "../utils/Carousel";
import "./LoginPage.scss";
import CustomPasswordField from "../utils/CustomPasswordField";
import { Link } from 'react-router-dom';
import CustomForm from "../utils/Form";
import Navbar from "../navigation/Navbar";
import LoginAPI from "../Apis/LoginAPI";
import { useState } from "react";
import gmailLogo from '../../images/gmail.png'
import { CheckCircle } from "@mui/icons-material";
import Footer from "../../components/app/Footer";

function SignupPage() {
  let benefits = LoginAPI.fetchLoginBenefits();
  const [isSignupSuccess, setIsSignupSuccess] = useState(false);

  return (
    <>
      <Navbar></Navbar>
      <div className="login-page-wrp wrapper">
        <div className="explain-wrp">
          <div className="desc-wrp">
            <Carousel
              numberOfCards={1}
              arrows={false}
              showDots={true}
              cards={toList(benefits, undefined, (c, i) => {
                return (
                  <div className="desc-card" key={i}>
                    <img className="desc-img" src={c.img} alt="desc-img"></img>
                    <div className="title">{c.title}</div>
                    <div className="sub-title">{c.subTitle}</div>
                  </div>
                );
              })}
            ></Carousel>
          </div>
        </div>
        <div className="login-wrp">
          {!isSignupSuccess ?
            <div className="login-container-wrp">
              <div className="title">Sign Up</div>
              <div className="login-btn-wrp">
                <Link reloadDocument={true} to='/login-with-google'>
                  <div className="inner-container">
                    <img className="gmail" src={gmailLogo} alt="gmail" />
                    <div className="text">Signup With Gmail</div>
                  </div>
                </Link>
              </div>
              <div className="divider">
                <div className="line"></div>
                <div className="Or">Or</div>
                <div className="line"></div>
              </div>
              <CustomForm
                onSubmit={(e, data) => { console.log(data); setIsSignupSuccess(true) }}
                data={{ name: "", email: "", password: "", remember: false }}
                render={(data, onChange) => (
                  <>
                    <div className="input-wrp">
                      <div className="label">Name</div>
                      <CustomTextField
                        name="name"
                        required={true}
                        className="input-box"
                        value={data?.name}
                        onChange={onChange}
                      />
                    </div>
                    <div className="input-wrp">
                      <div className="label">E-Mail Id</div>
                      <CustomTextField
                        name="email"
                        type="email"
                        helperText="* Incorrect Email id. Please enter correct Email id"
                        required={true}
                        className="input-box"
                        value={data?.email}
                        onChange={onChange}
                      />
                    </div>
                    <div className="password-wrp">
                      <div className="label">Password</div>
                      <div className="pwd-input-wrp">
                        <CustomPasswordField
                          name="password"
                          className="masked-input"
                          value={data?.password}
                          onChange={onChange}
                        />
                      </div>
                    </div>
                    <div className="forgot-pwd-wrp">
                      <div className="remember-wrp">
                        <Checkbox
                          name="remember"
                          checked={data?.remember}
                          onChange={onChange}
                          required={true}
                          label='I Accept The Terms & Condition'
                        ></Checkbox>
                      </div>
                    </div>
                    <div className="submit-wrp">
                      <button className="submit-btn" type="submit">
                        <div className="Login">Sign Up</div>
                      </button>
                      <div className="msg">
                        Already have an account?{" "}
                        <Link reloadDocument={true} to="/login">
                          <span>Login</span>
                        </Link>
                      </div>
                    </div>
                  </>
                )}
              ></CustomForm>
            </div> :
            <div className="signup-wrp">
              <div className="signup-msg-wrp">
                <div className="signup-success-wrp">
                  <CheckCircle className="icon"></CheckCircle>
                  <div className="title">Registered Successfully</div>
                  <div className="sub-title">
                    Proceed to upload your works and find jobs or find talents by clicking below button.
                  </div>
                </div>
                <Link reloadDocument={true} to='/home'>
                  <div className="start-working-wrp">
                    <div className="start-Working">Start Working</div>
                  </div></Link>
              </div>
            </div>
          }
        </div>
      </div>
      <Footer />
    </>
  );
}

export default SignupPage;
